export default {
  zh: {
    companyName: "公司名",
    businessExplain: "我们将按选项的顺序测试公司名称是否可以申请到。请不要在提议的实体名称中包含任何后缀，例如:Sdn. Bhd.",
    caution: "至少有1名董事的常住地须为马来西亚",
    check: "我们同意聘用由星中商务推荐的名义董事1名，我们也理解该名义董事的行为造成的任何法律影响均与EStar无关。",
    registeredAddressTitle: "注册地址",
    serviceAddressTitle: "服务地址",
    serviceAddressType: "服务地址类型",
    sameAsRegisteredAddress: "与注册地址相同",
    sameAsResidentialAddress: "与居住地址相同",
    residentialAddressTitle: "居住地址",
    otherAddress: "其他地址",
    addressLine1: "地址1",
    addressLine2: "地址2",
    addressLine3: "地址3",
    city: "城市",
    state: "州/邦/省",
    postcode: "邮编",
    country: "国家",
    // 马来西亚专属 - 公司额外信息
    entityType: "实体类型",
    companyRegistrationNumber: "注册号码",
    companyType: "公司类型",
    placeOfIncorporation: "成立地点",
    // 马来西亚专属 - 个人额外信息
    gender: "性别",
    occupation: "职位(举例: 企业经营者, 首席执行官, 高级管理人员等)",
    race: "种族",
    paidInCapital: "发行股份(即实收资本)",
    paidInCapitalMax: "仅限1~100",
  },
  en: {
    companyName: "Company name",
    businessExplain:
      "We will follow the option sequence of proposed entity name to check whether such name can be applied in Gov's system. Please do not include any suffix in the proposed entity name e.g. Sdn. Bhd.",
    caution: "At lease one director's permanent residence must be in Malaysia (i.e. either a Malaysian or Malaysia PR).",
    check:
      'We consent to appoint one Nominee Director recommended by Estar Business Advisory Sdn. Bhd. ("EStar"), and we understand that any legal impact caused by the Nominee Director\'s action has nothing to do with EStar.',
    registeredAddressTitle: "Registered Address",
    serviceAddressTitle: "Service Address",
    serviceAddressType: "Service Address Type",
    sameAsRegisteredAddress: "Same as Registered Address",
    sameAsResidentialAddress: "Same as Residential Address",
    residentialAddressTitle: "Residential Address",
    otherAddress: "Other Address",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    addressLine3: "Address Line 3",
    city: "City",
    state: "State",
    postcode: "Postcode",
    country: "Country",
    // Malaysia-specific - Company additional info
    entityType: "Entity Type",
    companyRegistrationNumber: "Registration Number",
    companyType: "Company Type",
    placeOfIncorporation: "Place of Incorporation",
    // Malaysia-specific - Individual additional info
    gender: "Gender",
    occupation: "Occupation (e.g. Businessman, CEO, Senior Officer, etc.)",
    race: "Race",
    paidInCapital: "Issued Share Capital (i.e. Paid-up capital)",
    paidInCapitalMax: "1 - 100 only",
  },
};
